var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loader',{attrs:{"object":"#ff9633","color1":"#ffffff","color2":"#17fd3d","size":"5","speed":"2","bg":"#343a40","objectbg":"#999793","opacity":"49","disableScrolling":"false","name":"dots"}})}
var staticRenderFns = []

export { render, staticRenderFns }